/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import { providesList } from '@helpers/index';
import BaseService from '../base';
import {
  ContractorWorkerParamsProps, ContractorWorkerApiProps, WorkerSectionFilterParams,
  CorpWorkersApiProps,
  CorpWorkerFilterParams,
  CorpWorkerApiProps,
  WorkerApiProps,
} from './types';

class Worker extends BaseService {
  deleteAllWorkers(secondaryUrl?: string) {
    return {
      query: (id: number) => ({
        url: secondaryUrl ? `${secondaryUrl}/${id}/workers` : `${this.url}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }],
    };
  }

  getContractorWorkers() {
    return {
      query: ({ contractorId, ...params }: ContractorWorkerParamsProps) => ({
        url: `/contractors/${contractorId}/workers-list`,
        params,
      }),
      providesTags: (result?: ContractorWorkerApiProps) => providesList(result?.workers, this.tagType),
    };
  }

  getSectionWorkers() {
    return {
      query: ({ sectionId, ...params }: WorkerSectionFilterParams) => ({
        url: `/sections/${sectionId}/workers-list`,
        params,
      }),
      providesTags: (result?: ContractorWorkerApiProps) => providesList(result?.workers, this.tagType),
    };
  }

  deleteContractorWorker() {
    return {
      query: (id : number) => ({
        url: `${this.url}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }],
    };
  }

  getCorpWorkers() {
    return {
      query: (params?: CorpWorkerFilterParams) => ({
        url: '/workers',
        params,
      }),
      providesTags: (result?: CorpWorkersApiProps) => providesList(result?.workers, this.tagType),
    };
  }

  createCorpWorker() {
    return {
      query: (params?: Partial<CorpWorkerApiProps>) => ({
        url: '/workers',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }],
    };
  }

  importContractorWorker() {
    return {
      query: ({ id, ...params }: Pick<WorkerApiProps, 'id'> & Partial<WorkerApiProps>) => ({
        url: `contractors/${id}/workers/import`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }],
    };
  }

  downloadContractorWorkersImportTemplate() {
    return {
      query: (contractorId: number) => ({
        url: `contractors/${contractorId}/${this.url}/import_template`,
        responseHandler: (response: Response) => response.blob(),
      }),
    };
  }

  updateCorpWorker() {
    return {
      query: ({ id, ...params }: Pick<CorpWorkerApiProps, 'id'> & Partial<CorpWorkerApiProps>) => ({
        url: `workers/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }],
    };
  }

  getContractorWorkersRutQuery() {
    return {
      query: ({ contractorId }: ContractorWorkerParamsProps) => ({
        url: `/contractors/${contractorId}/workers/document_numbers`,
      }),
      providesTags: (result?: ContractorWorkerApiProps) => providesList(result?.workers, this.tagType),
    };
  }

  getCorpWorker() {
    return {
      query: (id: number) => ({
        url: `workers/${id}`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: ContractorWorkerApiProps) => [{ type: this.tagType }],
    };
  }
}

export default new Worker('contractor_workers', 'Worker');
